export type ImageOrientation = "portrait" | "square" | "landscape";

export interface ImageSize {
  width: number;
  height: number;
}

export type OrientationSizeMap = Partial<Record<ImageOrientation, ImageSize>>;

export interface PlatformImageSpec {
  sizes?: OrientationSizeMap;
}

export const platformImageSpecs = {
  instagram: {
    sizes: {
      portrait: { width: 1080, height: 1350 },
      square: { width: 1080, height: 1080 },
      landscape: { width: 1080, height: 566 },
    },
  },
  twitter: {
    sizes: {
      portrait: { width: 1200, height: 675 },
      square: { width: 1200, height: 675 },
      landscape: { width: 1200, height: 675 },
    },
  },
};

export type SupportedPlatform = keyof typeof platformImageSpecs;

export function getPlatformImageSpec(platform?: SupportedPlatform): PlatformImageSpec {
  if (!platform) return {};
  return platformImageSpecs[platform];
}

export function detectOrientation(width: number, height: number): ImageOrientation {
  if (width === height) return "square";
  return width > height ? "landscape" : "portrait";
}

export function pickSizeForImage(
  sizes: OrientationSizeMap | undefined,
  width: number,
  height: number
): ImageSize | undefined {
  if (!sizes) return undefined;
  const orientation = detectOrientation(width, height);
  return sizes[orientation] ?? sizes.square ?? sizes.portrait ?? sizes.landscape;
}
